import axios from "axios";
import { resolveApiUrl } from "../../../assets/GlobalVariables";
import {
  attachAgentSessionToBody,
  buildAgentSessionRequestConfig,
} from "../../../services/agentApiSession";
import { entitlementsDebug } from "../entitlementsDebug";

const ENTITLEMENTS_PATH = "/api/agents/me/entitlements";

function entitlementsUrl() {
  return resolveApiUrl(ENTITLEMENTS_PATH);
}

/**
 * POST agent entitlements (read-only on server). Requires agent session.
 * @returns {Promise<object>} API JSON body
 */
export async function fetchAgentEntitlements() {
  const { sid, headers, withCredentials, timeout } =
    await buildAgentSessionRequestConfig({ timeout: 20000 });
  const body = attachAgentSessionToBody({ sessionID: sid });
  const url = entitlementsUrl();
  entitlementsDebug("POST", url, { sessionIdPrefix: sid.slice(0, 6) });
  const res = await axios.post(url, body, {
    headers,
    withCredentials,
    timeout,
  });
  return res.data;
}
